export default __webpack_public_path__ + "static/media/googleplay_zh-tw_badge_web.0e7f9ad2.png";